import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { createFeatureSelector, createSelector } from '@ngrx/store';

import {
  PackagingActionsUnion,
  PackagingActionTypes
} from '@core/actions/packaging.actions';

import { Follow, User } from '../../../models';

export interface FollowGroup {
  id: number;
  name: string;
  createdAt: Date;
  updatedAt: Date;
}

export interface Packaging {
  id: number;
  followGroupsId: number;
  followId: number;
  Follow: Follow[];
  FollowGroup: FollowGroup[];
  User: User[];
  status: number;
  parentId: number;
  createdAt: Date;
  updatedAt: Date;
  deletedAt: Date;
}

export interface State extends EntityState<Packaging> {
  loading: boolean;
  loaded: boolean;
  isBusy: boolean;
  packagingById: any[];
  dataForUpdate: any;
  message: string;
  packagingCountriesBusiness: any[];
  isUploadMassiveProviders: any[];
  packagingMilestones: any[]
  packagingsMaster: any[]
}

export const adapter: EntityAdapter<Packaging> = createEntityAdapter<Packaging>(
  {
    selectId: (packaging: Packaging) => packaging.id
  }
);

export const INITIAL_STATE: State = adapter.getInitialState({
  loading: false,
  loaded: false,
  isBusy: false,
  packagingById: [],
  dataForUpdate: {},
  message: '',
  packagingCountriesBusiness: [],
  isUploadMassiveProviders: [],
  packagingMilestones: [],
  packagingsMaster: []
});

export function reducer(
  state: State = INITIAL_STATE,
  action: PackagingActionsUnion
) {
  switch (action.type) {
    case PackagingActionTypes.DuplicateWithCodes:
    case PackagingActionTypes.UploadProcessUpdateAccept:
    case PackagingActionTypes.DeleteManagementFollowPackaging:
    case PackagingActionTypes.AddManagementFollowPackaging:
    case PackagingActionTypes.Delete:
    case PackagingActionTypes.Update:
    case PackagingActionTypes.LoadPackaging:
    case PackagingActionTypes.LoadPackagingById:
    case PackagingActionTypes.ImportFile:
    case PackagingActionTypes.ExportPackOrder:
    case PackagingActionTypes.FetchAllMasterPackagings:
      return { ...state, loading: true, isBusy: true };

    case PackagingActionTypes.ExportPackagingPending:
    case PackagingActionTypes.PackagingExportMassivePending:
      return { ...state, loading: true, message: action.message };

    case PackagingActionTypes.GetPackagingCountriesSuccess:
      return {
        ...state,
        loading: false,
        packagingCountriesBusiness: action.data
      };

    case PackagingActionTypes.ExportPackagingSuccess:
    case PackagingActionTypes.PackagingFieldsUpdateFail:
    case PackagingActionTypes.PackagingFieldsUpdateSuccess:
      return {...state, loading: false, message: ""}
    
    case PackagingActionTypes.PackagingExportMassiveFinish:
      return { ...state, loading: false, message: '' };

    case PackagingActionTypes.PackagingPendingMessage:
      return { ...state, loading: true, message: action.message };

    case PackagingActionTypes.DuplicateWithCodesSuccess:
    case PackagingActionTypes.ExportPackOrderSuccess:
    case PackagingActionTypes.ExportPackOrderLoadSuccess:
    case PackagingActionTypes.ExportPackOrderFail:
    case PackagingActionTypes.DuplicateWithCodesFail:
    case PackagingActionTypes.LoadPackagingFail:
      return {
        ...state,
        loading: false,
        loaded: true,
        isBusy: false,
        message: ''
      };

    case PackagingActionTypes.FetchAllMasterPackagingsSuccess:
      console.log("ATION -Z", action)
      return {
        ...state,
        packagingsMaster: action.data
      }

    case PackagingActionTypes.UploadProcessSuccess:
      return {
        ...state,
        loading: false,
        loaded: true,
        isBusy: false,
        message: '',
        isUploadMassiveProviders: action.data.errors
      };

    case PackagingActionTypes.LoadPackagingSuccess:
      return adapter.addAll(action.data, {
        ...state,
        loading: false,
        loaded: true,
        isBusy: false
      });

    case PackagingActionTypes.LoadPackagingByIdSuccess:
      return {
        ...state,
        loading: false,
        loaded: true,
        isBusy: false,
        packagingById: [action.data]
      };

    case PackagingActionTypes.DeleteSuccess:
      return {
        ...state,
        loading: false,
        loaded: true,
        isBusy: false
      };

    case PackagingActionTypes.CreatePackaging:
      return adapter.addOne(action.data, state);

    case PackagingActionTypes.UpdateSuccess:
      return adapter.updateOne(
        { id: action.id, changes: action.data },
        {
          ...state,
          loading: true,
          loaded: false,
          isBusy: true
        }
      );

    case PackagingActionTypes.UploadProcessUpdate:
      return {
        ...state,
        loading: false,
        loaded: true,
        isBusy: false,
        dataForUpdate: action.data
      };

    case PackagingActionTypes.GetPackagingMilestonesSuccess:
      return {
        ...state,
        loading: false,
        isBusy: false,
        packagingMilestones: action.data
      };
  

    // case PackagingActionTypes.UpdateSuccess:
    //     return adapter.upsertMany(action.data, {
    //     ...state,
    //     loading: false,
    //     loaded: true,
    //     isBusy: false
    // });

    case PackagingActionTypes.ClearState:
      return INITIAL_STATE;

    default:
      return state;
  }
}
export const getState = createFeatureSelector<State>('packaging');

export const {
  selectIds,
  selectEntities,
  selectAll,
  selectTotal
} = adapter.getSelectors();

export const getAll = createSelector(
  getState,
  selectAll
);

export const getAllPackaging = createSelector(
  getState,
  getAll
);

export const selectLoaded = (state: State) => state.loaded;
export const selectLoading = (state: State) => state.loading;

export const getIsLoading = createSelector(
  getState,
  selectLoading
);

export const getCountriesPackBusiness = createSelector(
  getState,
  (state: State) => state.packagingCountriesBusiness
);

export const getIsBusy = createSelector(
  getState,
  (state: State) => state.isBusy
);

const selectdataForUpdate = (state: State) => state.dataForUpdate;

const selectProviderMassiveUpload = (state: State) => state.isUploadMassiveProviders;

export const getDataForUpdate = createSelector(
  getState,
  selectdataForUpdate
);

export const getIsUploadMassiveProviderErrors = createSelector(
  getState,
  selectProviderMassiveUpload
)

const selectpackagingById = (state: State) => state.packagingById;

export const getStatePackagingById = createSelector(
  getState,
  selectpackagingById
);

export const geSpinnertMessage = createSelector(
  getState,
  state => state.message
);

export const getPackagingMilestones = createSelector(
  getState,
  state => state.packagingMilestones
);

export const getPackagingsMaster = createSelector(
  getState,
  state => state.packagingsMaster
);
